<template>
	<!-- <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10"> -->
	<div>
		<el-row class="toolbar">
			<el-button type="primary" :style="responsive.isMobile ? 'margin: 10px' : 'primary'" @click="agregarAlCarrito" :loading="loadingCart"
				>Agregar<i class="el-icon-shopping-cart-2"></i
			></el-button>
		</el-row>
		<div style="height: 1000px; overflow-y: auto; overflow-x: none;">
			<el-table :data="products" style="width: 100%;" v-loading="loadingallproductos" element-loading-text="Cargando datos...">
				<el-table-column label="Imagen" width="100">
					<template v-slot="{ row }">
						<el-image class="pic" :src="imageSrcProd(row)" fit="contain">
							<div slot="placeholder" class="pic slot">
								Cargando...
							</div>
							<div slot="error" class="pic slot">SIN FOTO</div>
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="nombre" label="Producto" :min-width="responsive.isMobile ? 100 : 130"></el-table-column>
				<el-table-column v-if="!responsive.isMobile" prop="codigo_alfanumerico" label="Código" min-width="90"></el-table-column>
				<!-- <el-table-column prop="codart" label="EAN" width="120"></el-table-column> -->
				<el-table-column label="Cantidad" width="90">
					<template v-slot="{ row }">
						<el-input v-model="row.cant" @input="updateTotals(row)" />
					</template>
				</el-table-column>
				<el-table-column prop="precio_lista_con_formato" label="Precio" :min-width="responsive.isMobile ? 100 : 140">
					<template v-slot="{ row }">
						<span>{{ formatCurrency(row.precio_lista) }}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="!responsive.isMobile" label="Sub total" :min-width="responsive.isMobile ? 100 : 140">
					<template v-slot="{ row }">
						<span v-if="row.subtotal !== undefined && row.subtotal !== null && row.subtotal !== 0">{{
							formatCurrency(row.subtotal)
						}}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="!responsive.isMobile" prop="bonificacion_uno_con_formato" label="Desc 1(%)" min-width="100"></el-table-column>
				<el-table-column v-if="!responsive.isMobile" prop="bonificacion_dos_con_formato" label="Desc 2(%)" min-width="100"></el-table-column>

				<el-table-column v-if="!responsive.isMobile" label="P.Unit c/Desc" min-width="140">
					<template v-slot="{ row }">
						<span>{{ formatCurrency(row.precioUnitarioDescuento) }}</span>
					</template>
				</el-table-column>
				<el-table-column :label="responsive.isMobile ? 'Total' : 'Total c/Desc'" min-width="140">
					<template v-slot="{ row }">
						<span v-if="row.totalConDescuento !== undefined && row.totalConDescuento !== null && row.totalConDescuento !== 0">{{
							formatCurrency(row.totalConDescuento)
						}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="products.length > 0">
				<div slot="footer" class="text-center" v-if="showBtnMore">
					<!--v-observe-visibility="loadMore"-->
					<el-button type="text" ref="loadMore" size="mini" @click="loadMoreClick" :loading="loading"
						>{{ loading ? 'Cargando...' : 'Mostrar más productos' }}<i class="el-icon-caret-bottom"></i
					></el-button>
				</div>
			</div>
			<div slot="footer" class="text-center" v-if="!showBtnMore">
				<p style="font-size: 12px; color: #969799;">No hay más registros.</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['responsive'],
	data() {
		return {
			loading: false,
			loadingCart: false,
			showBtnMore: false,
			qtyCache: {},
			pendingReload: false,
		};
	},
	computed: {
		filtrosStore() {
			return this.$store.state.pedidos.filter;
		},
		products() {
			return this.$store.state.pedidos.allproductos;
		},
		idcarrito() {
			return this.$store.state.pedidos.idcarrito;
		},
		total() {
			return this.$store.state.pedidos.total;
		},
		filter() {
			return this.$store.state.pedidos.filter;
		},
		allstart() {
			return this.$store.state.pedidos.allstart;
		},
		alllimit() {
			return this.$store.state.pedidos.alllimit;
		},
		allpage() {
			return this.$store.state.pedidos.alllimit;
		},
		cooperativa() {
			return this.$store.state.config.cuit;
		},
		loadingallproductos() {
			return this.$store.state.pedidos.loadingallproductos;
		},
		hasMore() {
			return Number(this.total) > Number((this.products || []).length);
		},
	},

	methods: {
		safeFirstFile(u) {
			try {
				if (!u) return null;

				if (typeof u === 'string') {
					const s = u.trim();
					if (!s) return null;
					if (s[0] === '[') {
						const arr = JSON.parse(s);
						return Array.isArray(arr) && typeof arr[0] === 'string' && arr[0].trim() ? arr[0] : null;
					}
					return s;
				}
				if (Array.isArray(u)) {
					const first = u[0];
					return typeof first === 'string' && first.trim() ? first : null;
				}

				if (typeof u === 'object') {
					if (typeof u[0] === 'string' && u[0].trim()) return u[0];
					if (typeof u.path === 'string' && u.path.trim()) return u.path;
				}
				return null;
			} catch (_) {
				return null;
			}
		},

		buildFileUrl(file) {
			const coop = encodeURIComponent(this.cooperativa);
			const arch = encodeURIComponent(file);
			return `./api/public/proxy/files?cooperativa=${coop}&type=pedidos&archivo=${arch}`;
		},

		imageSrcProd(producto) {
			const f = this.safeFirstFile(producto && producto.url);
			return f ? this.buildFileUrl(f) : '';
		},
		cacheQuantities() {
			const cache = {};
			for (const p of this.products || []) {
				if (p && p.id != null && p.cant != null && p.cant !== '') cache[p.id] = p.cant;
			}
			this.qtyCache = cache;
		},
		reapplyQuantities() {
			for (const row of this.products || []) {
				const cant = this.qtyCache[row.id];
				if (cant != null && cant !== '') {
					this.$set(row, 'cant', cant);
					this.updateTotals(row);
				}
			}
		},
		async reloadFast() {
			if (this.loading) {
				this.pendingReload = true;
				return;
			}
			this.loading = true;

			// 1) guardá cantidades antes de limpiar
			this.cacheQuantities();

			// 2) reiniciá lista/paginado “all”
			await this.$store.dispatch('resetAllProductos');
			await this.$store.dispatch('loadAllStart', 0);

			// 3) pedí primera página con los filtros vigentes del store
			await this.$store.dispatch('loadAllProductos');

			// 4) reponé cantidades y totales
			this.reapplyQuantities();
			this.showBtnMore = this.hasMore;
			this.loading = false;

			if (this.pendingReload) {
				this.pendingReload = false;
				this.reloadFast();
			}
		},

		loadMoreClick() {
			const start = this.allstart + this.alllimit;
			this.$store.dispatch('loadAllStart', start);
			this.$store.dispatch('loadAllProductos');
		},
		updateTotals(product) {
			product.subtotal = product.cant * product.precio_lista;
			product.totalConDescuento = product.cant * product.precio_lista * (1 - parseFloat(product.bonificacion_uno) / 100);
			product.precioUnitarioDescuento = product.precio_lista * (1 - parseFloat(product.bonificacion_uno) / 100);
		},
		agregarAlCarrito() {
			this.loadingCart = true;
			// Filtra los productos con cantidad mayor a cero
			const productosConCantidad = this.products.filter(product => product.cant > 0);

			if (productosConCantidad.length === 0) {
				this.$message.warning('No hay productos con cantidad seleccionada');
				return;
			}

			// Establece el estado de carga
			//this.loading = true;

			// Itera sobre los productos con cantidad mayor a cero y los agrega al carrito
			Promise.all(
				productosConCantidad.map(producto => {
					// Despachar la acción para agregar el producto al carrito
					producto.pedido_id = this.idcarrito;
					producto.pedido_cantidad = producto.cant;
					return this.$store.dispatch('addProducto', producto);
				})
			)
				.then(() => {
					//
					this.$store.dispatch('resetAllProductos').then(() => {
						this.$store.dispatch('loadAllProductos');
					});
					/*this.products.map(producto => {
						producto.cant = null;
						producto.subtotal = null;
						producto.totalConDescuento = null;
					});*/
					this.$message.success('Productos agregados al carrito con éxito');
				})
				.catch(error => {
					this.$message.error('Error al agregar productos al carrito: ' + error);
				})
				.finally(() => {
					// Restablece el estado de carga
					//this.loading = false;
					this.loadingCart = false;
				});
		},
		formatCurrency(value) {
			// Asegúrate de que el valor sea un número
			if (typeof value !== 'number') value = parseFloat(value);
			if (isNaN(value)) return '$ 0,00'; // Valor por defecto si no es un número válido

			// Forzar siempre dos decimales y usar un formato adecuado con punto para miles y coma para decimales
			return (
				'$ ' +
				value
					.toFixed(2) // Asegura 2 decimales
					.replace(/\B(?=(\d{3})+(?!\d))/g, '.') // Coloca puntos como separador de miles
					.replace(/.(\d{2})$/, ',$1')
			); // Mantiene la coma como separador decimal
		},
		// loadMore() {
		// 	let start = this.allstart + this.alllimit;
		// 	//let page = this.allpage + 1;
		// 	this.$store.dispatch('loadAllStart', start);
		// 	//this.$store.dispatch('loadAllPage', page);
		// 	this.$store.dispatch('loadAllProductos').then(() => {});
		// },
		// loadMoreClick() {
		// 	let start = this.allstart + this.alllimit;
		// 	//let page = this.allpage + 1;
		// 	this.$store.dispatch('loadAllStart', start);
		// 	this.$store.dispatch('loadAllProductos').then(() => {});
		// },
	},
	watch: {
		filtrosStore: {
			deep: true,
			immediate: true,
			handler() {
				this.reloadFast();
			},
		},
		// products(products) {
		// 	this.total > parseInt(products.length) ? (this.showBtnMore = true) : (this.showBtnMore = false);
		// },
		products() {
			this.showBtnMore = this.hasMore;
		},
	},
	// mounted() {
	// 	this.$store.dispatch('loadAllProductos');
	// },
};
</script>

<style scoped>
.toolbar {
	display: flex;
	justify-content: flex-end; /* Alinea el contenido (botón) a la derecha */
	margin-bottom: 20px;
}
.pic {
	min-width: 60px;
	width: 80px;
	height: 60px;
	vertical-align: top;
}
.pic.slot {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #efefef;
	font-size: 12px;
}
</style>
